import { useMemo } from 'react';

import { UseOptionsQueryParams, UseOptionsQueryReturnType } from '@/components/FilterNew/types';
import useAcademyRelatedConnections from '@/modules/lyearn-connect/hooks/useAcademyRelatedConnections';

import { getEntityFilterGroups } from '../../../utils';
import { getAcademyFilterOption } from '../utils';

function useAcademyOptionsQuery({ searchText }: UseOptionsQueryParams): UseOptionsQueryReturnType {
  const { error, connections, fetching } = useAcademyRelatedConnections({
    filters: { searchText },
  });

  const groups = useMemo(
    () => getEntityFilterGroups(connections, getAcademyFilterOption),
    [connections],
  );

  return {
    error,
    groups,
    fetching,
  };
}

export default useAcademyOptionsQuery;
